/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAppInsights extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAppInsights");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAppInsights.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAppInsights>): ServiceAccountNativeDetailsForAppInsights {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAppInsights(), model);
        ServiceAccountNativeDetailsForAppInsights.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAppInsights>): ServiceAccountNativeDetailsForAppInsights {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAppInsights.newInstance(<ServiceAccountNativeDetailsForAppInsights> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAppInsights) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAppInsights.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAppInsights): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAppInsights.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
